import React from 'react';
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel
} from '@headlessui/react';
import { MinusSmIcon, PlusSmIcon } from '@heroicons/react/solid';
import localizedRoute from '../../../utils/localizedRoute';
import { ICategory } from '../../../models';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';

const SubCategoryFilter = ({
  category,
  mobile,
  ui
}: {
  category: ICategory;
  mobile?: boolean;
  ui?: string;
}) => {
  const { t } = useTranslation();
  const {
    name,
    children = [],
    slug = '',
    id_category = '',
    category_name = ''
  } = category;
  const { count: categoryCount = 0 } = category || {};

  if (!children || children.length === 0) {
    return (
      <Link
        href={localizedRoute(`/shop${slug.startsWith('/') ? '' : '/'}${slug}`)}
        className={`px-5 min-w-0 flex-1 opacity-60 block py-1 ${
          !mobile && ui ? 'text-white' : ''
        }`}
      >
        {name || category_name}{' '}
        {/* <span className="align-top text-xs ml-1 opacity-60">
          ({categoryCount})
        </span> */}
      </Link>
    );
  }

  return (
    <Disclosure
      as="div"
      className="border-t border-black border-opacity-20 px-4 py-6"
    >
      {({ open }) => (
        <>
          <h3 className="-mx-2 -my-3 flow-root">
            <DisclosureButton
              className={`${mobile ? 'bg-white' : ''} 
                ml-3 w-full flex items-center justify-between opacity-60 hover:opacity-100`}
            >
              <span className="font-bold opacity-60">
                {name || category_name}
              </span>
              <span className="ml-6 flex items-center">
                {open ? (
                  <MinusSmIcon className="h-5 w-5" aria-hidden="true" />
                ) : (
                  <PlusSmIcon className="h-5 w-5" aria-hidden="true" />
                )}
              </span>
            </DisclosureButton>
          </h3>
          <DisclosurePanel className="pt-4">
            <Link
              href={localizedRoute(
                `/shop${slug.startsWith('/') ? '' : '/'}${slug}`
              )}
              className="px-5 min-w-0 flex-1 opacity-60 block py-1"
            >
              {t('VIEW_ALL')}
              <span className="align-top text-xs ml-1  opacity-60">
                ({categoryCount})
              </span>
            </Link>
            {children.map((child, i) => {
              return (
                <SubCategoryFilter key={i} category={child} mobile={mobile} />
              );
            })}
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
};

export default SubCategoryFilter;
